import { isEmpty } from 'lodash';
import { ConcessionProps } from '../types';

const getDefaultSelectedConcessionType = (
  concessionData: ConcessionProps | undefined
) => {
  if (!isEmpty(concessionData?.fixedAmount?.toString())) {
    return 'FIXED_AMOUNT';
  }

  if (!isEmpty(concessionData?.fixedPercentage?.toString())) {
    return 'FIXED_PERCENTAGE';
  }

  if (!isEmpty(concessionData?.dateWiseConcession?.[0].amount?.toString())) {
    return 'DATE_WISE_AMOUNT';
  }

  if (
    !isEmpty(concessionData?.dateWiseConcession?.[0].percentage?.toString())
  ) {
    return 'DATE_WISE_PERCENTAGE';
  }
};

export { getDefaultSelectedConcessionType };
